import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Footer() {
  const handleAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const { ref, revealed } = useScrollReveal();
  return (
    <footer ref={ref} className={`bg-background-100 text-foreground-900 transition-all duration-1000 ${revealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-label text-[10px] tracking-[0.12em] uppercase text-foreground-600 mb-4">
              Keiji Nakatsu
            </p>
            <p className="font-heading fw-bold text-3xl md:text-5xl leading-[0.95] tracking-[-0.04em] text-foreground-950">
              Strategy.
              <br />
              <span className="fw-medium marker-yellow text-foreground-950">Implementation.</span>
            </p>
            <p className="mt-6 text-sm text-foreground-700 max-w-md leading-relaxed">
              事業・顧客課題を構造化し、ブランド・CX・コミュニケーションを統合して実装までリードできるプロフェッショナルのキャリアポートフォリオ。
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-label text-[10px] tracking-[0.12em] uppercase text-foreground-500 mb-4">
              Navigate
            </p>
            <ul className="space-y-2">
              {[
                { id: 'works', label: 'Works' },
                { id: 'approach', label: 'Approach' },
                { id: 'profile', label: 'Profile' },
                { id: 'contact', label: 'Contact' },
              ].map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleAnchor(n.id);
                    }}
                    className="text-sm text-foreground-800 link-underline cursor-pointer"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-label text-[10px] tracking-[0.12em] uppercase text-foreground-500 mb-4">
              Elsewhere
            </p>
            <ul className="space-y-2 text-sm text-foreground-800">
              <li className="flex items-center gap-2">
                <i className="ri-behance-line text-base w-5 h-5 flex items-center justify-center" />
                <a href="#contact" className="link-underline cursor-pointer" onClick={(e) => { e.preventDefault(); handleAnchor('contact'); }}>Behance</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-linkedin-box-line text-base w-5 h-5 flex items-center justify-center" />
                <a href="#contact" className="link-underline cursor-pointer" onClick={(e) => { e.preventDefault(); handleAnchor('contact'); }}>LinkedIn</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-instagram-line text-base w-5 h-5 flex items-center justify-center" />
                <a href="#contact" className="link-underline cursor-pointer" onClick={(e) => { e.preventDefault(); handleAnchor('contact'); }}>Instagram</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base w-5 h-5 flex items-center justify-center" />
                <a href="mailto:bananagraphysm@gmail.com" className="link-underline cursor-pointer">Email</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-background-300 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-label text-[10px] tracking-[0.12em] uppercase text-foreground-500">
            Confidential Proprietary / Copyright © 2026 Keiji Nakatsu. All Rights Reserved.
          </p>
          <p className="font-label text-[10px] tracking-[0.12em] uppercase text-foreground-500">
            Tokyo, Japan · CX / Brand / Business Design
          </p>
        </div>
      </div>
    </footer>
  );
}